// import { useState, useEffect } from "react";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useMutation } from "@tanstack/react-query";
// import { toast } from "react-toastify";
// import { useForm, Controller } from "react-hook-form";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import Label from "../../ChildComponents/Label";
// import Input from "../../ChildComponents/Input";
// import BrandButton from "../../ChildComponents/BrandButton";
// import { Rolechema } from "../validation/roleValidation";
// import { useCreatePage, useUpdatePage } from "../../store/api/pageApi";

// // ReactQuill modules with all tools including image
// const quillModules = {
//   toolbar: [
//     [{ header: [1, 2, 3, 4, 5, 6, false] }],
//     [{ font: [] }],
//     [{ size: ["small", false, "large", "huge"] }],
//     ["bold", "italic", "underline", "strike"],
//     [{ color: [] }, { background: [] }],
//     [{ script: "sub" }, { script: "super" }],
//     [{ list: "ordered" }, { list: "bullet" }],
//     [{ indent: "-1" }, { indent: "+1" }],
//     [{ direction: "rtl" }],
//     [{ align: [] }],
//     ["blockquote", "code-block"],
//     ["link", "image", "video"],
//     ["clean"],
//   ],
//   clipboard: {
//     matchVisual: false,
//   },
// };

// const quillFormats = [
//   "header",
//   "font",
//   "size",
//   "bold",
//   "italic",
//   "underline",
//   "strike",
//   "color",
//   "background",
//   "script",
//   "list",
//   "bullet",
//   "indent",
//   "direction",
//   "align",
//   "blockquote",
//   "code-block",
//   "link",
//   "image",
//   "video",
// ];

// function Form({ data, editId, onSuccessCreated }) {
//   const createPage = useCreatePage({});
//   const updatePage = useUpdatePage(editId?.slug || {});
//   const [loading, setLoading] = useState(false);
//   const [edited, setEdited] = useState(editId ? true : false);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//     control,
//     watch,
//   } = useForm({
//     resolver: yupResolver(Rolechema),
//   });

//   useEffect(() => {
//     if (editId) {
//       reset({
//         title: editId.title || "",
//         slug: editId.slug || "",
//         details: editId.details || "",
//       });
//       setEdited(true);
//     } else {
//       reset({
//         title: "",
//         slug: "",
//         details: "",
//       });
//       setEdited(false);
//     }
//   }, [editId, reset]);

//   const mutation = useMutation({
//     mutationFn: (data) => {
//       return editId ? updatePage(data) : createPage(data);
//     },
//     onSuccess: (data) => {
//       setLoading(false);
//       toast.success(editId ? "Updated Successfully" : "Created Successfully");
//       reset();
//       onSuccessCreated(1);
//     },
//     onError: (error) => {
//       toast.error(error.message);
//       setLoading(false);
//     },
//   });

//   const onSubmit = async (formData) => {
//     setLoading(true);
//     try {
//       const data = {
//         title: formData.title,
//         slug: formData.slug,
//         details: formData.details,
//       };
//       mutation.mutate(data);
//     } catch (error) {
//       toast.error("Something went wrong.");
//       console.error(error);
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container-fluid p-0">
//       {/* Header Section */}
//       <div
//         className="mb-4 p-4 rounded-4 position-relative overflow-hidden"
//         style={{
//           background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//           boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
//         }}
//       >
//         <div className="d-flex align-items-center">
//           <div
//             className="d-flex align-items-center justify-content-center rounded-3 me-3"
//             style={{
//               width: "48px",
//               height: "48px",
//               background: "rgba(255, 255, 255, 0.2)",
//               backdropFilter: "blur(10px)",
//             }}
//           >
//             <i
//               className="material-icons"
//               style={{ color: "white", fontSize: "28px" }}
//             >
//               {editId ? "edit_document" : "description"}
//             </i>
//           </div>
//           <div>
//             <h4 className="text-white mb-1 fw-bold">
//               {editId ? "Edit Page" : "Create New Page"}
//             </h4>
//             <p
//               className="text-white mb-0"
//               style={{ opacity: 0.9, fontSize: "0.9rem" }}
//             >
//               {editId
//                 ? "Update page content and settings"
//                 : "Create a new page for your website"}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Form Section */}
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <div
//           className="p-4 rounded-4 shadow-sm"
//           style={{
//             background: "white",
//             border: "1px solid #e2e8f0",
//           }}
//         >
//           {/* Basic Information Section */}
//           <div className="mb-4">
//             <div className="d-flex align-items-center mb-3">
//               <div
//                 className="d-flex align-items-center justify-content-center rounded-2 me-2"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   background:
//                     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 }}
//               >
//                 <i
//                   className="material-icons"
//                   style={{ color: "white", fontSize: "18px" }}
//                 >
//                   info
//                 </i>
//               </div>
//               <h5 className="mb-0 fw-semibold" style={{ color: "#2d3748" }}>
//                 Page Information
//               </h5>
//             </div>

//             <div className="row">
//               <div className="col-lg-6 col-md-6">
//                 <Input
//                   icon="title"
//                   {...register("title")}
//                   error={errors.title?.message}
//                   type="text"
//                   placeholder="ex: Privacy Policy"
//                   label="Page Title"
//                 />
//               </div>

//               <div className="col-lg-6 col-md-6">
//                 <Input
//                   icon="link"
//                   {...register("slug")}
//                   error={errors.slug?.message}
//                   type="text"
//                   placeholder="ex: privacy"
//                   label="Page Slug"
//                 />
//                 <small
//                   className="text-muted d-flex align-items-center mt-1"
//                   style={{ fontSize: "0.8rem" }}
//                 >
//                   <i
//                     className="material-icons me-1"
//                     style={{ fontSize: "14px" }}
//                   >
//                     help_outline
//                   </i>
//                   URL-friendly version of the page title
//                 </small>
//               </div>
//             </div>
//           </div>

//           {/* Content Section */}
//           <div className="mb-4">
//             <div className="d-flex align-items-center mb-3">
//               <div
//                 className="d-flex align-items-center justify-content-center rounded-2 me-2"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   background:
//                     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 }}
//               >
//                 <i
//                   className="material-icons"
//                   style={{ color: "white", fontSize: "18px" }}
//                 >
//                   edit_note
//                 </i>
//               </div>
//               <h5 className="mb-0 fw-semibold" style={{ color: "#2d3748" }}>
//                 Page Content
//               </h5>
//             </div>

//             <div className="row">
//               <div className="col-12">
//                 <Label label="Description" />
//                 <Controller
//                   name="details"
//                   control={control}
//                   defaultValue=""
//                   render={({ field }) => (
//                     <div
//                       className="rounded-3 overflow-hidden shadow-sm"
//                       style={{ border: "1px solid #e2e8f0" }}
//                     >
//                       <ReactQuill
//                         {...field}
//                         theme="snow"
//                         modules={quillModules}
//                         formats={quillFormats}
//                         className="bg-white"
//                         onChange={(content) => field.onChange(content)}
//                         style={{ minHeight: "400px" }}
//                         placeholder="Write your page content here..."
//                       />
//                     </div>
//                   )}
//                 />
//                 <small
//                   className="text-muted d-flex align-items-center mt-2"
//                   style={{ fontSize: "0.8rem" }}
//                 >
//                   <i
//                     className="material-icons me-1"
//                     style={{ fontSize: "14px" }}
//                   >
//                     info
//                   </i>
//                   Use the toolbar to format text, add images, videos, and links
//                 </small>
//               </div>
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="d-flex align-items-center justify-content-between pt-3 border-top">
//             <div
//               className="d-flex align-items-center text-muted"
//               style={{ fontSize: "0.85rem" }}
//             >
//               <i className="material-icons me-1" style={{ fontSize: "18px" }}>
//                 schedule
//               </i>
//               {editId
//                 ? "Last updated: " + new Date().toLocaleDateString()
//                 : "Fill all required fields"}
//             </div>

//             <div className="d-flex gap-2">
//               {editId && (
//                 <button
//                   type="button"
//                   className="btn btn-light rounded-3 px-4"
//                   onClick={() => reset()}
//                   style={{
//                     border: "1px solid #e2e8f0",
//                     transition: "all 0.3s ease",
//                   }}
//                 >
//                   <i
//                     className="material-icons me-2"
//                     style={{ fontSize: "18px", verticalAlign: "middle" }}
//                   >
//                     refresh
//                   </i>
//                   Reset
//                 </button>
//               )}

//               <BrandButton
//                 type="submit"
//                 title={
//                   loading ? (
//                     <>
//                       <span
//                         className="spinner-border spinner-border-sm me-2"
//                         role="status"
//                         aria-hidden="true"
//                       ></span>
//                       {editId ? "Updating..." : "Creating..."}
//                     </>
//                   ) : (
//                     <>
//                       <i
//                         className="material-icons me-2"
//                         style={{ fontSize: "18px", verticalAlign: "middle" }}
//                       >
//                         {editId ? "save" : "add_circle"}
//                       </i>
//                       {editId ? "Update Page" : "Create Page"}
//                     </>
//                   )
//                 }
//                 disabled={loading}
//                 className="rounded-3 px-4 shadow"
//                 style={{
//                   background:
//                     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                   border: "none",
//                   minWidth: "160px",
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </form>

//       <style>{`
//         /* ReactQuill Toolbar Styling */
//         .ql-toolbar {
//           border-radius: 12px 12px 0 0 !important;
//           border-color: #e2e8f0 !important;
//           background: #f8f9fa !important;
//           padding: 12px !important;
//         }

//         .ql-toolbar .ql-stroke {
//           stroke: #4a5568 !important;
//         }

//         .ql-toolbar .ql-fill {
//           fill: #4a5568 !important;
//         }

//         .ql-toolbar .ql-picker-label {
//           color: #4a5568 !important;
//         }

//         .ql-toolbar button:hover,
//         .ql-toolbar button:focus,
//         .ql-toolbar button.ql-active {
//           color: #667eea !important;
//         }

//         .ql-toolbar button:hover .ql-stroke,
//         .ql-toolbar button.ql-active .ql-stroke {
//           stroke: #667eea !important;
//         }

//         .ql-toolbar button:hover .ql-fill,
//         .ql-toolbar button.ql-active .ql-fill {
//           fill: #667eea !important;
//         }

//         /* ReactQuill Container Styling */
//         .ql-container {
//           border-radius: 0 0 12px 12px !important;
//           border-color: #e2e8f0 !important;
//           font-size: 0.95rem !important;
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
//         }

//         .ql-editor {
//           min-height: 400px !important;
//           padding: 20px !important;
//         }

//         .ql-editor.ql-blank::before {
//           color: #a0aec0 !important;
//           font-style: normal !important;
//         }

//         /* Button Hover Effects */
//         .btn:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
//         }

//         .btn:active {
//           transform: translateY(0);
//         }

//         /* Quill Image Styling */
//         .ql-editor img {
//           max-width: 100%;
//           height: auto;
//           border-radius: 8px;
//           margin: 10px 0;
//         }

//         /* Quill Video Styling */
//         .ql-editor iframe {
//           max-width: 100%;
//           border-radius: 8px;
//           margin: 10px 0;
//         }

//         /* Quill Link Styling */
//         .ql-editor a {
//           color: #667eea;
//           text-decoration: underline;
//         }

//         .ql-editor a:hover {
//           color: #764ba2;
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Form;

import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { useQuill } from "react-quilljs"; // ✅ Changed
import "quill/dist/quill.snow.css"; // ✅ Changed
import Label from "../../ChildComponents/Label";
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";
import { Rolechema } from "../validation/roleValidation";
import { useCreatePage, useUpdatePage } from "../../store/api/pageApi";

function Form({ data, editId, onSuccessCreated }) {
  const createPage = useCreatePage({});
  const updatePage = useUpdatePage(editId?.slug || {});
  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);
  const [pageContent, setPageContent] = useState(""); // ✅ State for editor content

  // ✅ Quill modules configuration
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ align: [] }],
      ["blockquote", "code-block"],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  // ✅ Setup Quill editor
  const { quill, quillRef } = useQuill({ modules: quillModules });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  // ✅ Handle Quill text changes
  useEffect(() => {
    if (quill) {
      quill.on("text-change", () => {
        const content = quill.root.innerHTML;
        setPageContent(content);
        setValue("details", content);
      });
    }
  }, [quill, setValue]);

  // ✅ Load edit data
  useEffect(() => {
    if (editId) {
      reset({
        title: editId.title || "",
        slug: editId.slug || "",
        details: editId.details || "",
      });

      // ✅ Load content into Quill
      if (quill && editId.details) {
        quill.clipboard.dangerouslyPasteHTML(editId.details);
      }

      setEdited(true);
    } else {
      reset({
        title: "",
        slug: "",
        details: "",
      });

      // ✅ Clear Quill
      if (quill) {
        quill.setText("");
      }

      setEdited(false);
    }
  }, [editId, reset, quill]);

  const mutation = useMutation({
    mutationFn: (data) => {
      return editId ? updatePage(data) : createPage(data);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success(editId ? "Updated Successfully" : "Created Successfully");
      reset();

      // ✅ Clear Quill after success
      if (quill) {
        quill.setText("");
      }

      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = async (formData) => {
    setLoading(true);
    try {
      const data = {
        title: formData.title,
        slug: formData.slug,
        details: pageContent || formData.details, // ✅ Use state
      };
      mutation.mutate(data);
    } catch (error) {
      toast.error("Something went wrong.");
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-0">
      {/* Header Section */}
      <div
        className="mb-4 p-4 rounded-4 position-relative overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
        }}
      >
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center rounded-3 me-3"
            style={{
              width: "48px",
              height: "48px",
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
            }}
          >
            <i
              className="material-icons"
              style={{ color: "white", fontSize: "28px" }}
            >
              {editId ? "edit_document" : "description"}
            </i>
          </div>
          <div>
            <h4 className="text-white mb-1 fw-bold">
              {editId ? "Edit Page" : "Create New Page"}
            </h4>
            <p
              className="text-white mb-0"
              style={{ opacity: 0.9, fontSize: "0.9rem" }}
            >
              {editId
                ? "Update page content and settings"
                : "Create a new page for your website"}
            </p>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="p-4 rounded-4 shadow-sm"
          style={{
            background: "white",
            border: "1px solid #e2e8f0",
          }}
        >
          {/* Basic Information Section */}
          <div className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <div
                className="d-flex align-items-center justify-content-center rounded-2 me-2"
                style={{
                  width: "32px",
                  height: "32px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                <i
                  className="material-icons"
                  style={{ color: "white", fontSize: "18px" }}
                >
                  info
                </i>
              </div>
              <h5 className="mb-0 fw-semibold" style={{ color: "#2d3748" }}>
                Page Information
              </h5>
            </div>

            <div className="row">
              <div className="col-lg-6 col-md-6">
                <Input
                  icon="title"
                  {...register("title")}
                  error={errors.title?.message}
                  type="text"
                  placeholder="ex: Privacy Policy"
                  label="Page Title"
                />
              </div>

              <div className="col-lg-6 col-md-6">
                <Input
                  icon="link"
                  {...register("slug")}
                  error={errors.slug?.message}
                  type="text"
                  placeholder="ex: privacy"
                  label="Page Slug"
                />
                <small
                  className="text-muted d-flex align-items-center mt-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  <i
                    className="material-icons me-1"
                    style={{ fontSize: "14px" }}
                  >
                    help_outline
                  </i>
                  URL-friendly version of the page title
                </small>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <div
                className="d-flex align-items-center justify-content-center rounded-2 me-2"
                style={{
                  width: "32px",
                  height: "32px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                <i
                  className="material-icons"
                  style={{ color: "white", fontSize: "18px" }}
                >
                  edit_note
                </i>
              </div>
              <h5 className="mb-0 fw-semibold" style={{ color: "#2d3748" }}>
                Page Content
              </h5>
            </div>

            <div className="row">
              <div className="col-12">
                <Label label="Description" />
                {/* ✅ Replace ReactQuill with useQuill */}
                <div
                  className="rounded-3 overflow-hidden shadow-sm"
                  style={{ border: "1px solid #e2e8f0" }}
                >
                  <div ref={quillRef} style={{ minHeight: "400px" }} />
                </div>
                {errors.details && (
                  <p className="text-danger mt-2">{errors.details.message}</p>
                )}
                <small
                  className="text-muted d-flex align-items-center mt-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  <i
                    className="material-icons me-1"
                    style={{ fontSize: "14px" }}
                  >
                    info
                  </i>
                  Use the toolbar to format text, add images, videos, and links
                </small>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="d-flex align-items-center justify-content-between pt-3 border-top">
            <div
              className="d-flex align-items-center text-muted"
              style={{ fontSize: "0.85rem" }}
            >
              <i className="material-icons me-1" style={{ fontSize: "18px" }}>
                schedule
              </i>
              {editId
                ? "Last updated: " + new Date().toLocaleDateString()
                : "Fill all required fields"}
            </div>

            <div className="d-flex gap-2">
              {editId && (
                <button
                  type="button"
                  className="btn btn-light rounded-3 px-4"
                  onClick={() => {
                    reset();
                    if (quill) {
                      quill.setText("");
                    }
                  }}
                  style={{
                    border: "1px solid #e2e8f0",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i
                    className="material-icons me-2"
                    style={{ fontSize: "18px", verticalAlign: "middle" }}
                  >
                    refresh
                  </i>
                  Reset
                </button>
              )}

              <BrandButton
                type="submit"
                title={
                  loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {editId ? "Updating..." : "Creating..."}
                    </>
                  ) : (
                    <>
                      <i
                        className="material-icons me-2"
                        style={{ fontSize: "18px", verticalAlign: "middle" }}
                      >
                        {editId ? "save" : "add_circle"}
                      </i>
                      {editId ? "Update Page" : "Create Page"}
                    </>
                  )
                }
                disabled={loading}
                className="rounded-3 px-4 shadow"
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  minWidth: "160px",
                }}
              />
            </div>
          </div>
        </div>
      </form>

      <style>{`
        /* ReactQuill Toolbar Styling */
        .ql-toolbar {
          border-radius: 12px 12px 0 0 !important;
          border-color: #e2e8f0 !important;
          background: #f8f9fa !important;
          padding: 12px !important;
        }

        .ql-toolbar .ql-stroke {
          stroke: #4a5568 !important;
        }

        .ql-toolbar .ql-fill {
          fill: #4a5568 !important;
        }

        .ql-toolbar .ql-picker-label {
          color: #4a5568 !important;
        }

        .ql-toolbar button:hover,
        .ql-toolbar button:focus,
        .ql-toolbar button.ql-active {
          color: #667eea !important;
        }

        .ql-toolbar button:hover .ql-stroke,
        .ql-toolbar button.ql-active .ql-stroke {
          stroke: #667eea !important;
        }

        .ql-toolbar button:hover .ql-fill,
        .ql-toolbar button.ql-active .ql-fill {
          fill: #667eea !important;
        }

        /* ReactQuill Container Styling */
        .ql-container {
          border-radius: 0 0 12px 12px !important;
          border-color: #e2e8f0 !important;
          font-size: 0.95rem !important;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
        }

        .ql-editor {
          min-height: 400px !important;
          padding: 20px !important;
        }

        .ql-editor.ql-blank::before {
          color: #a0aec0 !important;
          font-style: normal !important;
        }

        /* Button Hover Effects */
        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
        }

        .btn:active {
          transform: translateY(0);
        }

        /* Quill Image Styling */
        .ql-editor img {
          max-width: 100%;
          height: auto;
          border-radius: 8px;
          margin: 10px 0;
        }

        /* Quill Video Styling */
        .ql-editor iframe {
          max-width: 100%;
          border-radius: 8px;
          margin: 10px 0;
        }

        /* Quill Link Styling */
        .ql-editor a {
          color: #667eea;
          text-decoration: underline;
        }

        .ql-editor a:hover {
          color: #764ba2;
        }
      `}</style>
    </div>
  );
}

export default Form;
